module.exports = __webpack_public_path__ + "img/ezeewallet.3651b435.svg";